/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import React from "react";
import { Link } from "react-router-dom";
import { useUser } from "~/Context/userContext";
import styled from "styled-components";
export const PageFooterWrapper = styled.section`
  margin: 80px 0 0 0;
  text-align: center;
  list-style: none;
  display: block;
  margin-bottom: 33px;
  li {
    margin-right: 20px;
    display: inline-block;
  }
  .footer-nav {
    padding-left: 0;
  }
  .footer-nav-login {
    /* hide login link for desktop */
    @media (min-width: 992px) {
      display: none;
    }
  }
`;

const PageFooter = (props) => {
  const { state: userState, dispatch } = useUser();
  if (!userState.loaded) {
    return null;
  }
  return (
    <PageFooterWrapper>
      <ul className="footer-nav">
        <li>
          <Link to="/">Today</Link>
        </li>
        <li>
          <Link to={`/archive`}>Archive</Link>
        </li>
        <li>
          <Link to={`/genres`}>Genres</Link>
        </li>
        <li>
          <Link to={`/chimneys`}>Chimneys</Link>
        </li>
        <li>
          <Link to={`/stats`}>Stats</Link>
        </li>
        <li>
          <Link to={`/shuffle`}>Shuffle</Link>
        </li>
        <li>
          <a href="//www.dreamchimney.com/promo" target="_blank" rel="noopener noreferrer">
            Promo Tracks
          </a>
        </li>

        <li>
          <a href="//www.dreamchimney.com/store" target="_blank" rel="noopener noreferrer">
            Store
          </a>
        </li>

        <li>
          <Link to={`/sitemap`}>Site Map</Link>
        </li>

        {userState && !userState.isChim && (
          <li>
            <Link to={`/join`}>Join Dream Chimney</Link>
          </li>
        )}
        {!userState.loggedin && (
          <li className="footer-nav-login">
            <a href="javascript:;" onClick={() => dispatch({ type: "signin_open" })}>
              Login
            </a>
          </li>
        )}
      </ul>
      {/* <Login opened={open} /> */}
    </PageFooterWrapper>
  );
};

export default PageFooter;
